module.exports = __webpack_public_path__ + "img/star.fb9e4ae.svg";